import { pathJoin } from '../../utils'

export const createUsersRouteMap = (prefix: string) => ({
  information: pathJoin(prefix)('information').chain,
  'api-keys': pathJoin(prefix)('api-keys').chain,
  'user-projects': pathJoin(prefix)('user-projects').chain,
})
